__webpack_require__.p = "/novel-studio/";